import { useTranslation } from 'react-i18next';
import { authenticatorRecoveryUrl } from '../auth/authClient';
import { SiteHeader } from '../app/SiteHeader';

interface SignInScreenProps {
  readonly onSignIn: () => void;
  /** #889: create an account (Keycloak's sign-up page). */
  readonly onSignUp?: () => void;
  readonly signInError?: string | null;
}

export function SignInScreen({ onSignIn, onSignUp, signInError }: SignInScreenProps) {
  const { t } = useTranslation();
  return (
    <>
      {/* #959: the shared header bar, with Help; signing in is this page's own job. */}
      <SiteHeader showAccount={false} />
      <main className="sign-in-screen">
        <div>
          <p className="eyebrow">{t('app.eyebrow')}</p>
          <h1>{t('signInScreen.heading')}</h1>
          <p>{t('signInScreen.body')}</p>
          {signInError ? (
            <p className="import-error" role="alert">
              {signInError}
            </p>
          ) : null}
          <div className="sign-in-screen-actions">
            <button type="button" onClick={onSignIn}>
              {t('signInScreen.signIn')}
            </button>
            {onSignUp ? (
              <button type="button" onClick={onSignUp}>
                {t('signInScreen.signUp')}
              </button>
            ) : null}
          </div>
          {/* #889 D5: sign-in has no password, so recovery is for a lost authenticator. */}
          <a className="sign-in-screen-recovery" href={authenticatorRecoveryUrl()}>
            {t('signInScreen.lostAuthenticator')}
          </a>
        </div>
      </main>
    </>
  );
}
